export default "__VITE_ASSET__lHoVay09__"